// MESSAGE TYPES
export const M_Error = 'Error';
export const M_Warning = 'Warning';
export const M_Success = 'Success';
export const M_Info = 'Information';
export const M_Noti = 'Notification';

// MESSAGE STATE NAME
export const S_Goals = 'STATE_GOALS';
export const S_Tasks = 'STATE_TASKS';

//GOAL MESSAGES
export const GOAL_M_SETTED = 'Goal is SET!🥳';
export const GOAL_M_UPDATED = 'Goal is Updated!😈';
export const GOAL_M_COMPLETED = 'This is a milestone!!🌱';
export const GOAL_M_REMOVED = 'Goal is Cancelled😒';

//TASK MESSAGES
export const TASK_M_SETTED = 'Tasks are created!🤩';
export const TASK_M_COMPLETED = 'One DOWN!!💪';
export const TASK_M_UPDATED = 'Tasks is Updated🙈';
export const TASK_M_REMOVED = 'Tasks is Cancelled👀';

// STATUS TYPES
export const DRAFT = 'Draft';
export const BEHIND = 'Behind';
export const ASSIGNED = 'Assigned';
export const PLANNED = 'Planned';
export const ON_PROGRESS = 'On-Progress';
export const COMPLETED = 'Completed';
export const POSTPONED = 'Postponed';
